import { Fragment, memo } from 'react';

import { InfoRow, InfoRowSection } from 'containers/components/EntityDetailV2';
import MarketingCampaignActivityContent from '../../../shared/MarketingCampaignActivityContent';

import ActivityDetailContainer from '../ActivityDetailContainer';

const MarketingCampaignGeneralDetail = memo(({ activity, labels, shared }) => {
    const { rightContent, titleRow } = shared;
    const subject = activity?.Campaign?.Subject;

    if (!activity?.Campaign) return null;

    return (
        <ActivityDetailContainer
            activity={activity}
            content={{
                main: subject && (
                    <InfoRowSection>
                        <InfoRow label={labels.subject} value={subject} />
                    </InfoRowSection>
                ),
                right: (
                    <Fragment>
                        {titleRow}
                        <MarketingCampaignActivityContent
                            campaign={activity.Campaign}
                            recipientsRightContent={rightContent}
                            variant="detail"
                        />
                    </Fragment>
                ),
            }}
        />
    );
});

MarketingCampaignGeneralDetail.displayName = 'MarketingCampaignGeneralDetail';

export default MarketingCampaignGeneralDetail;
